class WorldCupLatestNews extends HTMLElement {
  #imageWrap;
  #items;
  #image;
  #resizeObserver;
  #mediaQuery;
  #onMediaChange = () => this.#syncHeight();
  #onImageLoad = () => this.#initObservers();

  connectedCallback() {
    this.#imageWrap = this.querySelector('.world-cup-news__image-wrap');
    this.#items = this.querySelector('.world-cup-news__items');

    if (!this.#imageWrap || !this.#items) return;

    this.#mediaQuery = window.matchMedia('(min-width: 990px)');
    this.#mediaQuery.addEventListener('change', this.#onMediaChange);

    this.#image = this.#imageWrap.querySelector('img');

    if (!this.#image) {
      this.#initObservers();
      return;
    }

    if (this.#image.complete) {
      this.#initObservers();
    } else {
      this.#image.addEventListener('load', this.#onImageLoad, { once: true });
    }
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.#mediaQuery?.removeEventListener('change', this.#onMediaChange);
    this.#image?.removeEventListener('load', this.#onImageLoad);
  }

  #initObservers() {
    if (this.#resizeObserver) return;

    this.#resizeObserver = new ResizeObserver(() => this.#syncHeight());
    this.#resizeObserver.observe(this.#imageWrap);
    this.#syncHeight();
  }

  #syncHeight() {
    if (!this.#mediaQuery?.matches) {
      this.style.removeProperty('--wc-news-panel-height');
      return;
    }

    const height = this.#imageWrap.offsetHeight;

    if (height > 0) {
      this.style.setProperty('--wc-news-panel-height', `${height}px`);
    }
  }
}

if (!customElements.get('world-cup-latest-news')) {
  customElements.define('world-cup-latest-news', WorldCupLatestNews);
}
